import "react-hot-loader/patch";
import "vanilla-autofill-event";
import React from "react";
import ReactDOM from "react-dom";
import { AppContainer } from "react-hot-loader";
import { ThemeProvider } from "styled-components";

import theme from "theme";
import CareSolvedPage from "components/pages/CareSolvedPage";

const appContainer = document.getElementById("care-solved-portal");
if (navigator.userAgent.indexOf("MSIE") >= 0) {
  const apology = document.createElement("div");
  apology.classList.add("wrap");
  apology.innerHTML = `
    <section>
      <div class="col-central slim">
        <h5 class="subtitle">Oh no!</h5>
        <h2>Something went wrong</h2>
        <p>We’re sorry but it appears your browser is not compatible with our care solved page. Please try again using a browser such as Chrome, Firefox or IE 11+.</p>
        <p>Alternatively you can call us on <a href="tel:02086291030">020 8629 1030</a> to speak to an advisor or use the button below to find other contact methods.</p>
        <a class="btn" href="/contact/">Contact SuperCarers</a>
      </div>
    </section>
  `;
  appContainer.appendChild(apology);
} else {
  const render = Component =>
    ReactDOM.render(
      <AppContainer>
        <ThemeProvider theme={theme}>
          <Component />
        </ThemeProvider>
      </AppContainer>,
      appContainer
    );

  render(CareSolvedPage);

  if (module.hot) {
    module.hot.accept("components/pages/CareSolvedPage", () =>
      render(CareSolvedPage)
    );
  }
}
